import React from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import ProtectedRoute from './ProtectedRoute';
import StorePage from 'views/Stores/Insight/storePage';
import NotFound from 'views/NotFound/NotFound';
import UserProfile from 'views/UserProfile';
import EvidencePage from 'views/Stores/Insight/evidencePage/evidence';

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/main',
  element: <ProtectedRoute element={<MainLayout />} />,
  children: [
    // {
    //   path: 'insights',
    //   element: <Insight />
    // },
    // {
    //   path: 'stores/layout',
    //   element: <StoreLayout />
    // },
    // {
    //   path: 'brands',
    //   element: <Brands />
    // },
    // {
    //   path: 'stores',
    //   element: <Customers />
    // },
    {
      path: 'stores/storeinsight',
      element: <StorePage />
    },
    // {
    //   path: 'stores/storevideo',
    //   element: <VideoPage />
    // },
    // {
    //   path: '/main/stores/storesettings',
    //   element: <Settings />
    // },
    {
      path: '/main/stores/evidence',
      element: <EvidencePage />
    },
    // {
    //   path: '/main/team',
    //   element: <Team />,
    //   children: [
    //     {
    //       path: 'edit/:id',
    //       element: <EditStore />
    //     }
    //   ]
    // },
    // { path: 'utils/util-typography', element: <UtilsTypography /> },
    // { path: 'sample-page', element: <SamplePage /> },
    {
      path: 'storePage',
      element: <StorePage />
    },
    {
      path: 'profile',
      element: <UserProfile />
    },
    // {
    //   path: 'settings',
    //   element: <Settings />
    // },
    { path: '*', element: <NotFound btn="Go back" flag="1" /> }
  ]
};

export default MainRoutes;
